export class AutoActionType {
  static APPELS_LOYER = "appels_loyers";
  static ATTESTATION_CHAUFFAGE = "attestation_chauffage";
  static RESILIATION_BAIL = "resiliation_bail";
  static REVISION_LOYER = "revision";
  static RETARD_LOYER = "retard_loyer";
  static AVIS_ECHEANCE = "avis_echeance";
  static CRG = "crg";
}
